module.exports = __webpack_public_path__ + "img/data_center_01.92661c17.png";